// extracted by mini-css-extract-plugin
export default {"tabList":"StoryAlbumList-module__tabList"};